import React from "react";
import { Link } from "react-router-dom";

const SITE_URL = /^https?:\/\/(www\.)?zemaxi\.com(\/[^#]*)?(#.*)?$/i;

/**
 * Client-side route for site links (including absolute zemaxi.com URLs),
 * new-tab anchor for everything else.
 */
export function toSitePath(href) {
  if (!href) return null;
  if (href.startsWith("/")) return href;
  const match = SITE_URL.exec(href);
  return match ? `${match[2] || "/"}${match[3] || ""}` : null;
}

export default function SmartLink({ href, children, ...props }) {
  const path = toSitePath(href);
  if (path) {
    return <Link to={path} {...props}>{children}</Link>;
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
      {children}
    </a>
  );
}
